import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage, IntlShape} from 'react-intl';
import GridList, {processPagingParams} from '../fw/GridList.react';
import {defaultPageSize} from '../fw/PagingGrid.react';
import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import deepCopy from 'deep-copy';

import './channel.scss';
import { Organisation } from '../../common/types/types';

interface ChannelListProps {
    asRow?: boolean;
    organisation: Organisation;
    relay?: object;
}

export class ChannelList extends React.Component<ChannelListProps> {

    typeName = 'channels';

    static propTypes = {
		asRow: PropTypes.bool,
        organisation: PropTypes.object.isRequired,
        relay: PropTypes.object,
    }

	componentDidMount() {
		if (urlMapping.isForceUpdate()) {
			this.props.relay.forceFetch();
		}
	}

	static hasAuthOptions(item) {

		return item.isAuthFilled;
	}

	static getTooltip(item) {
		if (ChannelList.hasAuthOptions(item)) {
			return '';
		}

		if (item.invalid) {
			return (<FormattedMessage defaultMessage="Connection is invalid" id="channelList.connectionIsInvalid" />);
		}

		return (<FormattedMessage defaultMessage="Authentication options are missing." id="channelList.authOptionsAreMissing" />);
	}

    render() {
        const {channels} = this.props.organisation;
        const list = channels;
        let type = types[this.typeName];

		let invalidChannels = deepCopy(list);

		invalidChannels.edges = invalidChannels.edges.filter(({node}) => !ChannelList.hasAuthOptions(node));
		list.edges = list.edges.filter(({node}) => ChannelList.hasAuthOptions(node));

        return (
            <div>
				{invalidChannels.edges.length > 0
					? <div className="invalidChannels">
						<div className="sectionHeader">
							<h3><FormattedMessage defaultMessage="{cnt, plural, one {Application requiring} other {Applications requiring}} your attention:" id="channelList.applicationsAttention" values={{cnt: invalidChannels.edges.length}} /></h3>
						</div>

						<GridList
							asRow={this.props.asRow}
							bothTitles
							edges={invalidChannels}
							iconProperty="channelDef.icon"
							metadata={type}
							pageInfo={invalidChannels.pageInfo}
							relay={this.props.relay}
							sortByTitle
							tagsProperty="channelDef.state"
							titleProperty="name"
							titleProperty2="channelDef.name"
							tooltip={ChannelList.getTooltip}
							urlMapping={urlMapping}
						/>
					</div>
					: null
				}

				<div className="sectionHeader">
					<h3><FormattedMessage defaultMessage="Connected applications:" id="channelList.usedApplications" /></h3>
				</div>

				<GridList
					asRow={this.props.asRow}
					bothTitles
					edges={list}
					iconProperty="channelDef.icon"
					metadata={type}
					pageInfo={list.pageInfo}
					relay={this.props.relay}
					sortByTitle
					tagsProperty="channelDef.state"
					titleProperty="name"
					titleProperty2="channelDef.name"
					tooltip={ChannelList.getTooltip}
					urlMapping={urlMapping}
				/>
            </div>
        );
    }
}

export default Relay.createContainer(ChannelList, {
    initialVariables: {
        first: defaultPageSize,
        after: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        organisation: () => Relay.QL`
            fragment on Organisation {
                channels(first: $first, after: $after, deleted: false) {
                    edges {
                        node {
                            name,
                            type,
                            channelDef {
                                id,
                                icon,
                                name,
                                state,
                                type,
								authType,
                            },
                            id,
							options,
							invalid,
							enabled,
							deleted,
							isAuthFilled,
                            organisation_id,
					        userOptions,
					        currentUserOptions,
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
                }
            }
        `,
    },
});
